import fetchApi from "./api";

export default async function trackAiUsage(feature) {
  const response = await fetchApi("/api/usage/ai", "POST", { feature });
  const payload = await response.json().catch(() => ({}));

  if (!response.ok) {
    const error = new Error(payload.error || "AI usage limit reached.");
    error.code = payload.error_code;
    error.limitKey = payload.limit_key;
    error.allowed = payload.allowed;
    error.current = payload.current;
    throw error;
  }

  return payload;
}

